import React from "react";

const SvgBBiconsCompanyInDifficulty = (props) => (
	<svg viewBox="0 0 200 200" {...props}>
		<g id="Obecn\xE9 ikony">
			<g>
				<g>
					<path d="M110.2,141.8l3.4-5.8h-8.8c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8h13.2l7.2-12.5h-20.4c-2.1,0-3.8-1.7-3.8-3.8
				s1.7-3.8,3.8-3.8h24.8l2.9-5.1c2.3-4,6.6-6.5,11.2-6.5c1.4,0,2.7,0.2,3.9,0.6V59.3c0-3.1-2.3-5.2-4.7-5.2h-45
				c-2.4,0-4.6,2.1-4.6,5.2v87.2c0,0.4,0,0.8,0.1,1.2h-3.7V13.2c0-2.3-1.7-4.6-4.4-4.6H20.4c-2.7,0-4.4,2.3-4.4,4.6v134.5H8.5
				c-2.1,0-3.9,1.7-3.9,3.9c0,2.1,1.7,3.9,3.9,3.9h93.9L110.2,141.8z M104.7,68.2h31.6c2.1,0,3.8,1.7,3.8,3.8c0,2.1-1.7,3.8-3.8,3.8
				h-31.6c-2.1,0-3.8-1.7-3.8-3.8C100.9,69.9,102.6,68.2,104.7,68.2z M104.7,88.3h31.6c2.1,0,3.8,1.7,3.8,3.8c0,2.1-1.7,3.8-3.8,3.8
				h-31.6c-2.1,0-3.8-1.7-3.8-3.8C100.9,90,102.6,88.3,104.7,88.3z M66.4,147.2h-27v-27.9c0-1.4,1-2.5,2.3-2.5h22.4
				c1.3,0,2.3,1.1,2.3,2.5V147.2z M81.7,79.9c0,2.1-1.7,3.7-3.8,3.7H27.8c-2.1,0-3.7-1.7-3.7-3.7v-0.1c0-2.1,1.7-3.7,3.7-3.7h50.1
				C80,76.1,81.7,77.8,81.7,79.9L81.7,79.9z M81.7,53.8c0,2.1-1.7,3.8-3.8,3.8H27.8c-2.1,0-3.7-1.7-3.7-3.8v-0.1
				c0-2.1,1.7-3.7,3.7-3.7h50.1C80,50,81.7,51.7,81.7,53.8L81.7,53.8z M81.7,27.7c0,2.1-1.7,3.7-3.8,3.7H27.8
				c-2.1,0-3.7-1.7-3.7-3.7v-0.1c0-2.1,1.7-3.7,3.7-3.7h50.1C80,23.9,81.7,25.6,81.7,27.7L81.7,27.7z"/>
					<path d="M145.5,105.2c-0.4-0.2-0.8-0.3-1.2-0.3C144.7,104.9,145.1,105,145.5,105.2z" />
				</g>
				<path d="M192.4,184.4l-22.3-38.5l-22.3-38.5c-1.9-3.3-6.6-3.3-8.5,0l-22.3,38.5l-22.3,38.5c-1.9,3.3,0.5,7.4,4.3,7.4h44.5h44.5
			C192,191.8,194.3,187.7,192.4,184.4z M147.5,181.7c-1.1,1-2.3,1.4-3.8,1.4c-1.5,0-2.7-0.5-3.8-1.4c-1.1-0.9-1.6-2.3-1.6-4
			c0-1.5,0.5-2.7,1.6-3.8c1-1,2.3-1.6,3.8-1.6c1.5,0,2.8,0.5,3.9,1.6c1.1,1,1.6,2.3,1.6,3.8C149.1,179.5,148.6,180.8,147.5,181.7z
			 M148.8,141.9l-1.5,17.7c-0.2,2.1-0.5,3.7-1.1,4.8c-0.6,1.1-1.5,1.7-2.7,1.7c-1.3,0-2.2-0.5-2.7-1.6c-0.5-1.1-0.9-2.7-1.1-5
			l-1.1-17.2c-0.2-3.3-0.3-5.8-0.3-7.2c0-2,0.5-3.5,1.6-4.6c1-1.1,2.4-1.7,4.1-1.7c2.1,0,3.4,0.7,4.1,2.1c0.7,1.4,1,3.5,1,6.2
			C149.1,138.7,149,140.3,148.8,141.9z"/>
			</g>
		</g>
	</svg>
);

export default SvgBBiconsCompanyInDifficulty;
